import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { BackOfficeContext } from "../BackOffice";
import ClassTemplate from "../../../components/classes/ClassTemplate";
import { Checkbox } from "semantic-ui-react";

const AddEditClassTemplate = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const { setClassesTemplates } = useContext(BackOfficeContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (template.class_name.length === 0 || !template.class_name.replace(/\s+/, "")) {
            $("#className").addClass("is-invalid");
            errors.push(t("error.noClassName"));
        }
        if (template.class_slots.length === 0) {
            $("#classSlots").addClass("is-invalid");
            errors.push(t("error.noClassSlots"));
        } else if (template.class_slots.length > 11 || template.class_slots === 0 || template.class_slots === "0") {
            $("#classSlots").addClass("is-invalid");
            errors.push(t("error.invalidClassSlots"));
        }
        if (template.class_duration.length === 0) {
            $("#classDuration").addClass("is-invalid");
            errors.push(t("error.noClassDuration"));
        } else if (template.class_duration.length > 11 || template.class_duration === 0 || template.class_duration === "0") {
            $("#classDuration").addClass("is-invalid");
            errors.push(t("error.invalidClassDuration"));
        }

        if (!template.instructor_user_id) {
            $("#classInstructorDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedInstructor"));
        }
        if (!template.class_level_code) {
            $("#classLevelsDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedClassLevel"));
        }
        if (!template.class_type_code) {
            $("#classTypesDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedClassType"));
        }
        if (!template.location_id) {
            $("#classLocationsDropdown").addClass("is-invalid");
            errors.push(t("error.noSelectedLocation"));
        }
        if (template.class_descr.length === 0 || !template.class_descr.replace(/\s+/, "")) {
            $("#classDescription").addClass("is-invalid");
            errors.push(t("error.noClassDescription"));
        } else if (template.class_descr.length > 255) {
            $("#classDescription").addClass("is-invalid");
            errors.push(t("error.classDescriptionTooLong"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e, i) => {
                list.push({ variant: "danger", message: e, id: i });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t(`info.${showView.params.templateID ? "updatingClassTemplate" : "creatingClassTemplate"}`) }]);
            setBlockForm(true);
            addEditTemplate();
        }
    };

    const addEditTemplate = async () => {
        const res = await postMethod("/create-edit-class-template", {
            template: template,
            templateID: showView.params.templateID,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "addedCT" }]);
            setClassesTemplates(null);
            changeView({ nav: "templates", sub: "classesTemplates" });
        } else setBlockForm(false);
    };

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    useEffect(() => {
        if (!loading) {
            const textarea = document.getElementById("classDescription");
            autoResize(textarea);
            textarea.addEventListener("input", function () {
                autoResize(this);
            });
        }
        // eslint-disable-next-line
    }, [loading]);

    useEffect(() => {
        if (template) {
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [template]);

    const setHeight = () => {
        $(`#addEditClassTemplate`).css("min-height", `${window.innerHeight - 61 - $("#goBackBtn").outerHeight() - $("#footerMain").outerHeight()}px`);
    };

    const getClassTemplateData = async () => {
        const res = await postMethod("/get-class-template-data", { templateID: showView.params.templateID });
        if (checkServerData(res)) {
            setTemplate(res.data.template);
            setLoading(false);
        }
    };

    useEffect(() => {
        setHeight();
        if (!showView.params.templateID) {
            setTemplate({
                class_name: "",
                class_descr: "",
                class_duration: "60",
                class_type_code: "",
                class_level_code: "",
                location_id: null,
                instructor_user_id: null,
                class_slots: "",
                class_template_active: true,
                instructor_label: "",
                early_cancel_available: true,
            });
            setLoading(false);
        } else getClassTemplateData();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Container fluid="lg" id="addEditClassTemplate">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t(`templates.${showView.params.templateID ? "edit" : "createNew"}ClassTemplate`)}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <ClassTemplate template={template} blockForm={blockForm} setTemplate={setTemplate} setFormChanged={setFormChanged} />
                                <Row>
                                    <Col xs={12} lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="w-100">{t(`status`)}</Form.Label>
                                            <Checkbox
                                                toggle
                                                label={t("templates.templateActive")}
                                                checked={template.class_template_active}
                                                disabled={blockForm}
                                                onChange={() => {
                                                    setTemplate({ ...template, class_template_active: !template.class_template_active });
                                                    $("#classTemplateActive").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                            {t(`templates.${showView.params.templateID ? "update" : "create"}Template`)}
                                        </Button>

                                        <Button variant="outline-secondary" className="float-end" onClick={() => changeView({ nav: "templates", sub: "classesTemplates" })}>
                                            {t("cancel")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default AddEditClassTemplate;
